import { OrderList } from '@app/store/reducers/salaryCards/businessCardOrder.api'
import { MasterCardIcon, VisaCardIcon } from '@modules/CustomIcons'
import { TableProps } from '@shared/Table'
import { Col, Row, Typography } from 'antd'
import { t } from 'i18next'

export const orderListColumns: () => TableProps<
  Omit<
    OrderList,
    'orderId' | 'transactionId' | 'currencyCommission' | 'customerName' | 'cardName' | 'totalFeeCurrency'
  >
>['editColumns'] = () => ({
  updatedDate: {
    title: t('orders.salaryCardOrder.tableTitles.date'),
    hasSorter: true,
    hasSelect: true,
    width: 120,
    fixed: 'left',
  },
  orderNo: {
    title: t('orders.salaryCardOrder.tableTitles.number'),
    hasSearch: true,
    width: 120,
  },
  cardSystem: {
    title: t('businessCardOrders.labels.cardName'),
    i18nKeyForLabel: 'orders.salaryCardOrder.constants',
    hasSelect: true,
    // ellipsis: true,
    width: 230,
    render(value, record) {
      return (
        <Row justify="start" align="middle" gutter={8}>
          <Col>{value === 'VISA' ? <VisaCardIcon /> : <MasterCardIcon />}</Col>
          <Col>{record.cardName}</Col>
        </Row>
      )
    },
  },
  cardCurrency: {
    title: t('orders.salaryCardOrder.tableTitles.cardCurrency'),
    hasSelect: true,
    width: 100,
    align: 'center',
  },
  orderType: {
    title: t('orders.salaryCardOrder.tableTitles.orderTypes'),
    i18nKeyForLabel: 'orders.salaryCardOrder.constants',
    hasSelect: true,
    width: 130,
    align: 'center',
    render(value) {
      return <>{t(`orders.salaryCardOrder.constants.${value}`)}</>
    },
  },
  orderDeliveryType: {
    title: t('orders.salaryCardOrder.tableTitles.receivingTransfer'),
    hasSelect: true,
    i18nKeyForLabel: 'orders.salaryCardOrder.constants',
    width: 130,
    align: 'center',
    render(value) {
      return <>{t(`orders.salaryCardOrder.constants.${value}`)}</>
    },
  },
  totalFee: {
    title: t('businessCardOrders.labels.currencyCommission'),
    width: 100,
    align: 'center',
    render(value, record) {
      return (
        <>
          <Typography.Text>{Number(value).toFixed(2)} {record.totalFeeCurrency}</Typography.Text>
        </>
      )
    },
  },
  status: {
    width: 100,
    title: t('orders.salaryCardOrder.tableTitles.status'),
    render(value) {
      return (
        <>
          {t(`businessCardOrders.buttonsLabels.RadioButtonGroup.${value}`)}
        </>
      )
    },
    fixed: 'right',
  },
})
